import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="print-temporary-slips"
export default class extends Controller {
  connect() {
    console.log("printTemporarySlipsController connected");
  }

  printTemporarySlips(event) {
    event.preventDefault();
    if (!confirm("本当に仮伝票を作成しますか？")) return;

    const delivery_group_ids = Array.from(
      document.querySelectorAll("[name*=delivery_group_ids]:checked")
    ).map((e) => e.value);

    if (delivery_group_ids.length === 0) {
      alert("仮伝票に追加する配車グループを選択してください。");
      return;
    }

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/delivery_groups/print_temporary_slips";
    form.target = "_blank";

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const csrfInput = document.createElement("input");
    csrfInput.type = "hidden";
    csrfInput.name = "authenticity_token";
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);

    delivery_group_ids.forEach((id) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "delivery_group_ids[]";
      input.value = id;
      form.appendChild(input);
    });

    const deliveredAt = document.querySelector("[name=delivered_at]").value;
    const deliveredAtInput = document.createElement("input");
    deliveredAtInput.type = "hidden";
    deliveredAtInput.name = "delivered_at";
    deliveredAtInput.value = deliveredAt;
    form.appendChild(deliveredAtInput);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
}
